import React from 'react'
import { Chip, Link, Typography, withStyles, Button, Paper, CircularProgress } from '@material-ui/core'
import { connect } from "react-redux";
import DeviceIcon from '../../../components/DeviceIcon'
import { formatCurrency } from '../../../util/formatters';
import SectionTitleContainer, { SectionTitle } from "../../../components/SectionTitleContainer";
import Adaptable from "../../../components/Adaptable";
import If from "../../../components/If";
import {errorBundaryHOC} from "../../../components/ErrorBoundary";
import {styles} from './styles'

class SummaryStep extends React.Component {

    getTotal() {
        let result = 0;
        this.props.appointmentData.items.forEach(device => {
            result += this.getSubtotal(device.issues);
        });
        return result;
    }

    getSubtotal(issues) {
        let result = 0;
        issues.forEach(issue => {
            result += issue.price;
        });
        return result;
    }

    getAddress() {
        let address = this.props.appointmentData.appointment_address.address;
        return `${address.address_line1} ${address.address_line2} ${address.locality} ${address.administrative_area} ${address.postal_code} ${address.country_code}`;
    }

    getIssuesView = id => {
        const step1 = this.props.appointmentData.items.filter(device => device.id === id)[0];
        return step1.issues.map(issue => {
            return (
                <Chip
                    key={issue.id}
                    className={this.props.classes.issueChip}
                    label={`${issue.title} - ${formatCurrency(issue.price)}`}
                />
            )
        });
    };
    getSubtotalByDevice = id => {
        const device = this.props.appointmentData.items.filter(item => item.id === id)[0];
        if (device.issues.length === 0)
            return 0;
        else {
            let issues = device.issues;
            let result = 0;
            for (let i = 0; i < issues.length; i++) {
                result = result + issues[i].price
            }
            return result;
        }
    };

    registerAppointment() {
        this.props.registerAppointment();
    }

    render() {
        const {classes, appointmentData, registeringAppointment} = this.props;
        return (
            <div>

                <Adaptable as={SectionTitleContainer} hideFromSmallDown>
                    <SectionTitle>Order Summary</SectionTitle>
                </Adaptable>

                <div className={classes.space}>

                    <div className={classes.movilPaper}>
                        <Typography variant="subtitle2" color='secondary' style={{ textAlign: 'justify', }}>
                            You will be charged with an initial amount of $26.75 (taxes included) to insert your request in the system, we
                            collect the grand total when we finish the service,
                            never before and never cash.
                        </Typography>
                        <br/>
                        <Link href='/terms' target='_blank' color='secondary' underline='always'
                              style={{ fontSize: '0.875rem' }}>Go to
                            terms and conditions for more info</Link>
                    </div>

                    <div className={classes.paper}>
                        <Typography color='primary' variant='subtitle1' style={{ fontWeight: 'bold' }}>
                            Total amount: {formatCurrency(this.getTotal())}
                        </Typography>
                        <Typography variant='subtitle2' className={classes.aptmInfo}>
                            Date: {appointmentData.appointment_date}
                        </Typography>
                        <Typography variant='subtitle2' className={classes.aptmInfo}>
                            Address: {this.getAddress()}
                        </Typography>
                    </div>

                    {
                        (appointmentData.items.map((device) => (
                                <div key={device.id} className={classes.paper}>
                                        <div className={classes.itemMainDiv}>
                                            <div className={classes.itemHeader}>
                                                <DeviceIcon deviceName={device.title}/>
                                                <Typography color='primary' variant="subtitle1" noWrap={true}
                                                            className={classes.itemTitle}>
                                                    {device.title}
                                                </Typography>
                                                <div className={classes.colorPaper}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="17" width="17"
                                                         viewBox="0 0 17 17">
                                                        <g>
                                                            <path id="path1"
                                                                  transform="rotate(0,8.5,8.5) translate(0,0) scale(0.53125,0.53125)  "
                                                                  fill={device.color.code}
                                                                  d="M16,0C24.837036,0 32,7.1629944 32,16 32,24.836975 24.837036,32 16,32 7.1630249,32 0,24.836975 0,16 0,7.1629944 7.1630249,0 16,0z"/>
                                                        </g>
                                                    </svg>
                                                    <Typography variant="subtitle2" align='center' noWrap={true}
                                                                className={classes.colorName}>
                                                        {device.color.name}
                                                    </Typography>
                                                </div>
                                            </div>
                                            <div className={classes.issuesDesktop}>
                                                <Typography gutterBottom variant="subtitle2" align='left'>
                                                    Issues {<span
                                                    style={{ fontWeight: 'bold' }}>({formatCurrency(this.getSubtotalByDevice(device.id))})</span>}
                                                </Typography>
                                                {this.getIssuesView(device.id)}
                                            </div>
                                            <div className={classes.issuesMobil}>
                                                <Typography gutterBottom variant="subtitle2" align='left'>
                                                    Price: {<span
                                                    style={{ fontWeight: 'bold' }}>({formatCurrency(this.getSubtotalByDevice(device.id))})</span>}
                                                </Typography>
                                            </div>
                                        </div>
                                    </div>
                                )
                            )
                        )
                    }

                    <div className={classes.desktopPaper}>
                        <span style={{ display: 'inline-flex', marginBottom: 10 }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24">
                                <g>
                                    <path id="path1" transform="rotate(0,12,12) translate(0,3.75) scale(0.75,0.75)  "
                                          fill="#000000"
                                          d="M18,16L25,16C25.552999,16 26,16.448 26,17 26,17.552 25.552999,18 25,18L18,18C17.447001,18 17,17.552 17,17 17,16.448 17.447001,16 18,16z M2,11L2,20 30.000977,20 30.000488,11z M2,7L2,9 30.00038,9 30.000271,7z M2,2L2,5 30.000162,5 30,2z M2,0L30,0C31.103027,0,32,0.89700317,32,2L32,20C32,21.102997,31.103027,22,30,22L2,22C0.89697266,22,0,21.102997,0,20L0,2C0,0.89700317,0.89697266,0,2,0z"/>
                                </g>
                            </svg>
                            <span
                                style={{marginLeft: '10px'}}>{appointmentData.payment.brand} ●●●● ●●●● ●●●● {appointmentData.payment.last4}</span>
                        </span>
                        <Typography variant="subtitle2" color='secondary'>
                            You will be charged with an initial amount of $26.75 (taxes included) to insert your request in the system, we
                            collect the grand total when we finish the service,
                            never before and never cash.
                        </Typography>
                        <br/>
                        <Link href='/terms' target='_blank' color='secondary' underline='always'
                              style={{ fontSize: '0.875rem' }}>Go to
                            terms and conditions for more info</Link>
                    </div>

                    <div className={classes.movilPaper}>
                        <span style={{ display: 'inline-flex' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 0 24 24">
                                <g>
                                    <path id="path1" transform="rotate(0,12,12) translate(0,3.75) scale(0.75,0.75)  "
                                          fill="#000000"
                                          d="M18,16L25,16C25.552999,16 26,16.448 26,17 26,17.552 25.552999,18 25,18L18,18C17.447001,18 17,17.552 17,17 17,16.448 17.447001,16 18,16z M2,11L2,20 30.000977,20 30.000488,11z M2,7L2,9 30.00038,9 30.000271,7z M2,2L2,5 30.000162,5 30,2z M2,0L30,0C31.103027,0,32,0.89700317,32,2L32,20C32,21.102997,31.103027,22,30,22L2,22C0.89697266,22,0,21.102997,0,20L0,2C0,0.89700317,0.89697266,0,2,0z"/>
                                </g>
                            </svg>
                            <span style={{
                                marginLeft: '10px',
                                lineHeight: '24px',
                            }}>{appointmentData.payment.brand} ●●●● ●●●● ●●●● {appointmentData.payment.last4}</span>
                        </span>
                    </div>

                </div>

                <Paper className={classes.fixedPaper}>
                    <Button className={classes.registerButton}
                            onClick={this.registerAppointment.bind(this)}
                            disabled={registeringAppointment}
                            color='secondary'
                            variant='contained'>
                        REGISTER APPOINTMENT <If as={CircularProgress} size={20} condition={registeringAppointment}/>
                    </Button>
                </Paper>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        appointmentData: state.appointmentData,
    }
};

const SummaryStepStyled = withStyles(styles)(SummaryStep);
export default connect(mapStateToProps)(errorBundaryHOC(SummaryStepStyled));
